import { Widget, WIDGET_STATISTICS_TOTALGOALS_DONUTS } from "@gaming/srvg-classes-core";


export class StatisticsTotalgoalsDonutsWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#statisticsTotalgoalsDonutsWidget';
        super( options );
        var that = this;

        this.name = 'widgetstatisticstotalgoalsdonuts';
        this.widgetName = options.widgetName || WIDGET_STATISTICS_TOTALGOALS_DONUTS
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {};
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addStatisticTotalgoalsDonutsWidget();
        super.handleDomInstantiated();
    }

    /**
     * add totalgoals statistic widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addStatisticTotalgoalsDonutsWidget(selector?) {
        var that = this;
        selector = selector || this.selector;


        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addStatisticTotalgoalsWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(selector, eventdata){
        this.addStatisticTotalgoalsDonutsWidget(selector);
    }

    /**
     * calls widget api setTeamIds to switch/set teams. Shows statistics of teams specified
     * @param team1uid number team id first team
     * @param team2uid number team id second team
     */
    setTeamIds(team1uid: number, team2uid: number){
        if(this.widget.api){
            this.widget.api.setTeamIds(team1uid, team2uid);
        }
    }

    /**
     * Changes markets that are displayed in the widget with markets for match that is on a given channel.
     * Channel parameter must be a number from 0 to 3 that represents the match channel.
     * @param integer video channel
     */
    setChannel(channel: number){
        if(this.widget.api){
            this.widget.api.setChannel(channel);
        }
    }

    /**
     * Selects a spread
     * @param spread
     */
    selectSpread(spread:any){
        if(this.widget.api){
            this.widget.api.selectSpread(spread);
        }
    }

    /**
     * Sets array of spreads
     * @param spreads (array) [ spread1, spread2, .. ]
     */
    setSpreads(spreads: any){
        if(this.widget.api){
            this.widget.api.setSpreads(spreads);
        }
    }

}